import type { FC } from 'react';
import React, { memo, useState } from 'react';

import { CommentButtonLazy } from './CommentButtonLazy.tsx';
import { CommentButtonPlaceholder } from './CommentButtonPlaceholder.tsx';
import { usePreloadCommentButton } from './usePreloadCommentButton.tsx';
import { fg } from '@confluence/feature-gating';

type CommentButtonWrapperProps = {
	contentId: string;
	isCommentButtonSSRd?: boolean;
};

const noop = () => {};

export const CommentButtonWrapper: FC<CommentButtonWrapperProps> = memo(
	({ contentId, isCommentButtonSSRd = false }) => {
		const { data, error } = usePreloadCommentButton(contentId, isCommentButtonSSRd);

		const contentNode = data?.commentData?.content?.nodes?.[0];

		const isFabricSuported = fg('confluence_comment_use_metadata')
			? (contentNode?.metadata?.frontend?.fabricEditorSupported ?? false)
			: contentNode?.properties?.nodes?.[0]?.value === '"v2"' ||
				contentNode?.properties?.nodes?.[0]?.value === 'v2';

		const [showCommentButton, setShowCommentButton] = useState(false);

		/* Scenario: A user has clicked on the button in SSR -> SPA transition.
     The mouse click event is captured and the loading of CommentButtonLazy is started.
     */
		const handleCommentButtonClick = () => {
			setShowCommentButton(true);
		};

		/*Conditional Loading of CommentButtonLazy if FF is ON and showCommentButton true (user click)*/

		/* in case of an error from CommentButtonQuery load CommentButtonLazy and allow CommentButton to make
          another network call to fetch data*/
		const isDataLoaded = Boolean(data?.commentData && !error);

		if (showCommentButton || error) {
			return (
				<>
					<CommentButtonLazy
						contentId={contentId}
						isDataLoaded={isDataLoaded}
						isFabricPage={isFabricSuported}
					/>
				</>
			);
		} else {
			return (
				<>
					<CommentButtonPlaceholder
						isDisabled={!isDataLoaded && !isCommentButtonSSRd}
						handleCommentButtonClick={
							isDataLoaded || isCommentButtonSSRd ? handleCommentButtonClick : noop
						}
						contentId={contentId}
					/>
				</>
			);
		}
	},
);
